import React, { Component } from 'react'
import { Col, Row } from 'react-flexbox-grid'
import Paper from '@material-ui/core/Paper'
import TitledLabel from '../../controls/TitledLabel'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import Icon from '@material-ui/core/Icon'
import { withStyles } from '@material-ui/core/styles'
import CardStyles from '../../styles/cards'
import { Colors } from '../../theme'
import classnames from 'classnames'

class MemberSelectRow extends Component {
  constructor () {
    super()
    this.select = this.select.bind(this)
  }

  select (e) {
    this.props.onClick(e)
  }
  render () {
    let member = this.props.member
    let selected = this.props.selectedMember
    const { classes = {} } = this.props
    return (
      <Paper className={classnames(classes.summaryCard, classes.select)} onClick={() => this.select(member)} elevation={selected ? (selected === member.patientId) ? 4 : 1 : 1}>
        <Row middle='xs' start='xs'>
          <Col xs={12} sm={12} md={4} lg={4} >
            <Row middle='xs' start='xs'>
              <Col>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={!!(selected === member.patientId)}
                      icon={<Icon style={{ color: Colors.Palette.primaryTextColor }}>check_box_outline_blank</Icon>}
                      checkedIcon={<Icon color='primary'>check_box</Icon>}
                    />
                  }
                />
              </Col>
              <Col >
                <p className='cardTitle'>{`${member.firstName} ${member.lastName}`}</p>
              </Col>
            </Row>
          </Col>
          <Col xs={12} sm={12} md={8} lg={8}>
            <Row middle='xs' start='xs'>
              <Col xs={12} sm={4} md={4} lg={3}>
                <TitledLabel title='pages.SubmitAClaim.MemberSelection.type' value={member.relationship} format='text' />
              </Col>
              <Col xs={12} sm={4} md={4} lg={3}>
                <TitledLabel title='pages.SubmitAClaim.MemberSelection.birthDate' value={member.birthDate} format='date' />
              </Col>
            </Row>
          </Col>
        </Row>
      </Paper>
    )
  }
}

const styles = {
  ...CardStyles,
  select: {
    cursor: 'pointer'
  }
}

export default withStyles(styles)(MemberSelectRow)



// WEBPACK FOOTER //
// ./src/widgets/SubmitAClaim/memberSelectRow.js